var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 28.0625L13.25 24.9385L5.20196 18.5005L13.25 12.0625L10.75 8.93845L0.749961 16.9385C0.515652 17.1258 0.326498 17.3635 0.196508 17.6339C0.066518 17.9043 -0.000976563 18.2004 -0.000976562 18.5005C-0.000976563 18.8005 0.066518 19.0966 0.196508 19.367C0.326498 19.6374 0.515652 19.8751 0.749961 20.0625L10.75 28.0625ZM29.25 8.93845L26.75 12.0625L34.798 18.5005L26.75 24.9385L29.25 28.0625L39.25 20.0625C39.4843 19.8751 39.6734 19.6374 39.8034 19.367C39.9334 19.0966 40.0009 18.8005 40.0009 18.5005C40.0009 18.2004 39.9334 17.9043 39.8034 17.6339C39.6734 17.3635 39.4843 17.1258 39.25 16.9385L29.25 8.93845ZM25.952 0.932453L17.952 36.9325L14.046 36.0645L22.046 0.0644531L25.952 0.932453Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.9c7683fea0a722c5cc0443651fedf03d.svg";
export { ForwardRef as ReactComponent };